module.exports = __webpack_public_path__ + "img/header-countryicon.788d283.webp";